<template>
  <div class="consumer-record">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="消费明细" name="shopping">
        <div class="search-bar">
          <el-form :model="queryParams" :rules="rules" inline>
            <el-row>
              <!--   <el-form-item label="流水号" prop="flowNum">
                <el-input
                  v-model="queryParams.flowNum"
                  placeholder="请输入流水号"
                ></el-input>
              </el-form-item>
              <el-form-item label="消费说明" prop="description">
                <el-input
                  v-model="queryParams.description"
                  placeholder="请输入消费说明"
                ></el-input>
              </el-form-item> -->
            </el-row>
            <el-row>
              <el-form-item label="消费时间">
                <el-date-picker
                  v-model="queryParams.dateRange"
                  type="daterange"
                  align="right"
                  unlink-panels
                  clearable
                  :default-time="['23:59:59', '00:00:00']"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleSearch">搜索</el-button>
                <el-button @click="resetQuery">重置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button
                  :loading="exportLoading"
                  type="primary"
                  class="export-btn"
                  @click="handleExport"
                  >导出消费明细</el-button
                >
              </el-form-item>
            </el-row>
          </el-form>
        </div>

        <el-table v-loading="loading" :data="recordList" style="width: 100%">
          <el-table-column
            prop="flowNum"
            label="流水号"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="description"
            label="消费说明"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="consumeType.consumeType"
            label="消费类型"
          ></el-table-column>
          <el-table-column prop="modifiedDate" label="消费时间">
            <template slot-scope="scope">
              {{
                scope.row.modifiedDate
                  ? moment(scope.row.modifiedDate).format("YYYY-MM-DD HH:mm")
                  : "---"
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="consumeCount"
            label="消费数量"
          ></el-table-column>
          <el-table-column
            prop="guobanCurrecyConsumption"
            label="消耗国版币"
          ></el-table-column>
        </el-table>

        <div class="pagination-container">
          <cus-pagination
            :total="total"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            @size-change="fetchConsumerRecords"
          ></cus-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="充值记录" name="recharge">
        <div class="recharge">
          <div class="search-bar">
            <el-form
              :inline="true"
              :model="rechargeQueryParams"
              class="demo-form-inline"
            >
              <!-- <el-form-item label="订单号">
                <el-input
                  v-model="rechargeQueryParams.orderNo"
                  placeholder="请输入订单号"
                  clearable
                  style="width: 200px"
                >
                </el-input>
              </el-form-item> -->
              <el-form-item label="创建日期">
                <el-date-picker
                  v-model="rechargeQueryParams.dateRange"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleRechargeSearch"
                  >查询</el-button
                >
                <el-button @click="resetRechargeQuery">重置</el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table
            v-loading="rechargeLoading"
            :data="rechargeList"
            style="width: 100%"
          >
            <el-table-column
              prop="orderNo"
              label="订单号"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="orderContent"
              label="订单内容"
              width="180"
            ></el-table-column>
            <el-table-column prop="orderType" label="订单类型">
              <template slot-scope="scope">
                {{
                  scope.row.orderType === "ONLINE_PAY" ? "线上支付" : "线下支付"
                }}
              </template>
            </el-table-column>
            <el-table-column prop="payCount" label="支付金额">
              <template slot-scope="scope">￥{{ scope.row.payCount }}</template>
            </el-table-column>
            <el-table-column prop="payType" label="支付方式">
              <template slot-scope="scope">
                <span v-if="scope.row.payType === 'WXPAY'">微信支付</span>
                <span v-else-if="scope.row.payType === 'ALIPAY'"
                  >支付宝支付</span
                >
                <span v-else-if="scope.row.payType === 'OFFLINEPAY'"
                  >线下支付</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="orderStatus" label="支付状态">
              <template slot-scope="scope">
                <el-tag
                  :type="
                    scope.row.orderStatus === 'PAID' ? 'success' : 'danger'
                  "
                >
                  {{
                    scope.row.orderStatus === "PAID" ? "支付成功" : "支付失败"
                  }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createdDate" label="创建时间">
              <template slot-scope="scope">
                {{
                  scope.row.createdDate
                    ? moment(scope.row.createdDate).format("YYYY-MM-DD HH:mm:ss")
                    : "-"
                }}
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-container">
            <cus-pagination
              :total="rechargeTotal"
              :current-page.sync="rechargeCurrentPage"
              :page-size.sync="rechargePageSize"
              @size-change="fetchRechargeRecords"
            ></cus-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  consumerDetailPage,
  getPayPage,
  exportConsumeDetail,
} from "@/api/combo";
import moment from "moment";
import CusPagination from "@/components/cusPagination.vue";
import axios from "axios";
import { requestUrl } from "@/config/config";

export default {
  name: "userDetailCharge",
  components: {
    CusPagination,
  },
  data() {
    return {
      recordList: [],
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      queryParams: {
        flowNum: "",
        description: "",
        consumeTypeId: "",
        dateRange: [],
        startDate: "",
        endDate: "",
      },
      pickerOptions: {
        // 可以添加日期选择器的快捷选项
      },
      activeTab: "shopping",
      rechargeQueryParams: {
        orderNo: "",
        dateRange: [],
        startDate: "",
        endDate: "",
      },
      rechargeLoading: false,
      rechargeList: [],
      rechargeTotal: 0,
      rechargeCurrentPage: 1,
      rechargePageSize: 20,
      exportLoading: false,
      rules: {
        flowNum: [
          {
            pattern: new RegExp("^[0-9]{0,50}$"),
            trigger: "blur",
            message: "请输入合法流水号",
          },
        ],
      },
    };
  },
  watch: {
    currentPage() {
      this.fetchConsumerRecords();
    },
    activeTab(newVal) {
      this.currentPage = 1;
      if (newVal === "shopping") {
        this.fetchConsumerRecords();
      } else if (newVal === "recharge") {
        // 这里可以添加获取充值记录的方法
        // this.fetchRechargeRecords();
        this.fetchRechargeRecords();
      }
    },
  },
  mounted() {
    this.fetchConsumerRecords();
  },
  created() {
    this.queryParams.createdBy = this.$route.params.subId;
  },
  methods: {
    async fetchConsumerRecords() {
      this.loading = true;
      try {
        const params = {
          pageSize: this.pageSize,
          pageNumber: this.currentPage,
          createdBy: this.$route.params.subId,
          startDate: this.queryParams.dateRange[0],
          endDate: this.queryParams.dateRange[1],
        };

        if (params.dateRange && params.dateRange.length === 2) {
          const [beginTime, endTime] = params.dateRange;
          params.startDate = moment(beginTime).format("YYYY-MM-DD");
          params.endDate = moment(endTime).format("YYYY-MM-DD");
          delete params.dateRange;
        }

        const response = await this.$ajax.get(consumerDetailPage(), params);
        console.log("response", response);
        this.recordList = response?.data?.rows || [];
        this.total = response?.data?.total || 0;
      } catch (error) {
        this.$message.error(`获取消费记录失败:${error}`);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchConsumerRecords();
    },
    resetQuery() {
      this.queryParams = {
        flowNum: "",
        description: "",
        consumeTypeId: "",
        dateRange: [],
        startDate: "",
        endDate: "",
      };
      this.currentPage = 1;
      this.fetchConsumerRecords();
    },
    async fetchRechargeRecords() {
      this.rechargeLoading = true;
      try {
        const params = {
          ...this.rechargeQueryParams,
          createdBy: this.$route.params.subId,
          pageSize: this.rechargePageSize,
          pageNumber: this.rechargeCurrentPage,
        };

        if (params.dateRange && params.dateRange.length === 2) {
          const [beginTime, endTime] = params.dateRange;
          params.startDate = moment(beginTime).format("YYYY-MM-DD HH:mm:ss");
          params.endDate = moment(endTime).format("YYYY-MM-DD HH:mm:ss");
          delete params.dateRange;
        }

        const response = await this.$ajax.get(getPayPage(), params);
        this.rechargeList = response?.data?.rows || [];
        this.rechargeTotal = response?.data?.total || 0;
      } catch (error) {
        this.$message.error(`获取充值记录失败:${error}`);
      } finally {
        this.rechargeLoading = false;
      }
    },
    handleRechargeSearch() {
      this.rechargeCurrentPage = 1;
      this.fetchRechargeRecords();
    },
    resetRechargeQuery() {
      this.rechargeQueryParams = {
        orderNo: "",
        dateRange: [],
        startDate: "",
        endDate: "",
      };
      this.rechargeCurrentPage = 1;
      this.fetchRechargeRecords();
    },
    handleExport() {
      this.exportLoading = true;

      const params = {
        // ...this.queryParams,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        // createdBy: this.$route.params.subId,
        userId: this.$route.params.subId,
      };

      // 如果有日期范围,添加开始和结束时间
      if (
        this.queryParams.dateRange &&
        this.queryParams.dateRange.length === 2
      ) {
        const [beginTime, endTime] = this.queryParams.dateRange;
        params.beginTime = moment(beginTime).format("YYYY-MM-DD 00:00:00");
        params.endTime = moment(endTime).format("YYYY-MM-DD 23:59:59");
      }

      axios({
        url: requestUrl + exportConsumeDetail,
        method: "get",
        params: params,
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (!res) return;
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel,charset=utf-8",
          });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "消费明细.xlsx";
          a.click();
          URL.revokeObjectURL(url);
          this.exportLoading = false;
        })
        .catch((err) => {
          this.$message.error("导出失败：" + err.message);
          this.exportLoading = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .el-table th {
  background-color: #f5f5f5 !important;
}

.consumer-record {
  padding: 20px;
  background-color: #ffffff;
}

.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  /* margin: 24px 0; */
}

.search-bar > * {
  margin-right: 10px;
  white-space: nowrap;
}

.search-bar .el-date-editor.el-input,
.search-bar .el-date-editor.el-input__inner,
.search-bar .el-select {
  width: auto;
}

/* 添加以下样式来改变表头背景颜色 */
.el-table th {
  background-color: #f5f5f5 !important;
}

.pagination-container {
  margin: 24px 0;
}

/* 添加以下样式以确保表单项在一行内显示 */
.demo-form-inline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.demo-form-inline .el-form-item {
  margin-right: 10px;
  margin-bottom: 10px;
}

/* 添加以下新样式 */
.search-btn {
  width: 1rem;
  height: 0.42rem;
  background: linear-gradient(180deg, #6877ff 0%, #4bbeff 100%);
  border-radius: 0.24rem;
}

.reset-btn {
  width: 1rem;
  height: 0.42rem;
  border-radius: 0.24rem;
}

.export-btn {
  background: #36c2cf;
  border-radius: 0.24rem;
}

.search-btn:hover,
.reset-btn:hover {
  opacity: 0.8;
}

.el-form-item {
  margin-bottom: 0;
}

.demo-form-inline .el-form-item:last-child {
  margin-right: 0;
}

/* ::v-deep .el-tabs__header {
  margin-bottom: 24px;
}
 */
::v-deep .el-tabs__nav-wrap::after {
  height: 1px;
}

.el-table {
  margin: 24px 0;
}

.el-row {
  margin-bottom: 16px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.recharge {
  margin-top: 16px;
}
</style>
